import { render, staticRenderFns } from "./SampleForms.vue?vue&type=template&id=79cb4460&"
import script from "./SampleForms.vue?vue&type=script&lang=js&"
export * from "./SampleForms.vue?vue&type=script&lang=js&"
import style0 from "./SampleForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports